(section_name=>{
// provide js within this function or remove the entire file if it's not needed

function waitUntil(predicate, time = 10000) {
    return new Promise(((resolve) => {
        let int = setInterval(() => {
            if (predicate()) {
                resolve(predicate());
                clearInterval(int);
                int = null;
            }
        }, 500);
        setTimeout(() => {
            if (int !== null) {
                clearInterval(int);
                console.log('condition false');
            }
        }, time);
    }));
}

waitUntil(() => typeof Swiper === 'function' && document.querySelector('.acc_bf_lp_01_01_review_box') !== null).then(() => {
    const reviewContainer = document.querySelector('.acc_bf_lp_01_01_review_box');
    if (reviewContainer) {
        new Swiper(reviewContainer, {
            slidesPerView: "auto",
            spaceBetween: 16,
            pagination: {
            el: ".swiper-pagination",
            clickable: true,
            },
        });
    }
});
})("acc_bf_lp_01_01");
